import React from 'react';
import { IMaskInput } from 'react-imask';
import styled from 'styled-components';
import InputStyles from './InputStyles';

interface IdentityProps {
  type?: string;
  disabled?: boolean;
  id?: string;
  phoneMasks?: Array<{ mask: string; type: string }>;
  placeholder?: string;
  onBlur?: (e: Event) => void;
  onChange?: (e: Event) => void;
  onAccept?: (val: string) => void;
  value?: string;
  inputMode?: string;
  phoneOnly?: boolean;
}

interface Mask {
  mask: string;
  type: string;
}

const IdentityInput = styled(IMaskInput)`
  ${InputStyles}
`;

const defaultPhoneMasks: Array<Mask> = [
  { mask: '000-000-0000  ', type: 'phone' },
  { mask: '(000) 000-0000', type: 'phone' },
  { mask: '+1 (000) 000-0000', type: 'phone' },
  { mask: '000.000.0000', type: 'phone' },
];

const Identity: React.FC<IdentityProps> = ({ placeholder = 'Email or Mobile', phoneMasks = defaultPhoneMasks, onAccept, inputMode, phoneOnly, ...props }) => {
  const anyMask = /[\s\S]+/i;
  const comboMask: any = {
    mask: [...phoneMasks, ...(phoneOnly ? [] : [{ mask: anyMask, type: 'anyMask' }])],
    unmask: true,
    lazy: false,
  };

  return (
    <IdentityInput
      data-cy="identity-input"
      {...comboMask}
      {...props}
      onAccept={(value: string) => {
        onAccept?.(value);
      }}
      maxLength={128}
      placeholder={placeholder}
      inputMode={inputMode}
    />
  );
};

export default Identity;
